// Mirrors server/lib/emailSearchMode.ts — no shared/ import path between client
// and server exists in this repo yet, so this tiny rule is duplicated rather
// than adding one. Keep both in sync if the rule changes.
export type EmailSearchMode = "query" | "account" | "range" | "none";

export function emailSearchMode(
  q: string,
  accountId: string | null | undefined,
  from: string | null | undefined,
  to: string | null | undefined,
): EmailSearchMode {
  if (q.trim()) return "query";
  if (accountId) return "account";
  if (from || to) return "range";
  return "none";
}
